import React from 'react';

export const FaucetSection: React.FC = () => {
  const handleFaucetClick = () => {
    window.open('https://claim.shido.io', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="flex items-center justify-between gap-4 px-4 py-3 rounded-xl bg-gradient-to-r from-primary-900/20 to-transparent border border-primary-800/20 backdrop-blur-sm">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-lg bg-primary-500/10 flex items-center justify-center flex-shrink-0">
          <svg className="w-4 h-4 text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
          </svg>
        </div>
        <div>
          <p className="text-sm text-gray-300">
            <span className="font-medium text-primary-300">Need SHIDO for gas?</span>
            <span className="text-gray-400 ml-2 hidden sm:inline">Claim free tokens from the community faucet</span>
          </p>
        </div>
      </div>
      <button
        onClick={handleFaucetClick}
        className="text-xs font-medium px-3 py-1.5 rounded-lg bg-primary-500/10 hover:bg-primary-500/20 text-primary-400 hover:text-primary-300 border border-primary-500/20 transition-all duration-200 flex items-center gap-1.5 flex-shrink-0"
      >
        Claim
        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
        </svg>
      </button>
    </div>
  );
};
